import React, { FormEvent, useState } from "react";
import { useDispatch } from "react-redux";
import { ErrorLoader } from "../../../../UI/Loaders/Loaders";
import { hideModal } from "../../../../redux/actions/modal";

interface IAdvancedCorporateSearchModal {
  onCloseModal: () => void;
  dataRecord: {
    onSearch?: (params: any) => void;
  };
}

interface ICorporateSearchParams {
  onboardingStatus?: string;
  searchValue?: string;
}

const AdvancedCorporateSearchModal: React.FC<IAdvancedCorporateSearchModal> = ({
  onCloseModal,
  dataRecord,
}) => {
  const [state, setState] = useState<ICorporateSearchParams>({
    onboardingStatus: "",
    searchValue: "",
  });

  const dispatch = useDispatch();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (dataRecord?.onSearch) {
      dataRecord.onSearch(state);
    }
    dispatch(hideModal());
  };

  const handleClear = () => {
    setState({
      onboardingStatus: "",
      searchValue: "",
    });
    if (dataRecord?.onSearch) {
      dataRecord.onSearch({
        onboardingStatus: "",
        searchValue: "",
      });
    }
    onCloseModal();
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <React.Fragment>
            <h3 className="Modal__title p-b-1">Advanced Corporate Search</h3>
            <div id="corporate-search-form">
              <div className="m-b-30">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="searchValue">Search Value:</label>
                      <input
                        type="text"
                        className="form-control"
                        id="searchValue"
                        value={state.searchValue}
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            searchValue: e.target.value,
                          }));
                        }}
                        placeholder="Enter business name, email, or RC number"
                        name="searchValue"
                      />
                      <small className="form-text text-muted">
                        Search by business name, email, or RC number
                      </small>
                    </div>

                    {/* <div className="col-md-6 col-sm-12 mt-2">
                      <label htmlFor="onboardingStatus">
                        Onboarding Status:
                      </label>
                      <select
                        className="form-control"
                        id="onboardingStatus"
                        value={state.onboardingStatus}
                        onChange={(e) => {
                          setState((prev) => ({
                            ...prev,
                            onboardingStatus: e.target.value,
                          }));
                        }}
                        name="onboardingStatus"
                      >
                        <option value="">All Statuses</option>
                        <option value="Pending">Pending</option>
                        <option value="InProgress">In Progress</option>
                        <option value="LegalInProgress">
                          Legal In Progress
                        </option>
                        <option value="Completed">Completed</option>
                        <option value="Approved">Approved</option>
                        <option value="Declined">Declined</option>
                      </select>
                    </div> */}
                  </div>

                  <div className="Form__action-buttons m-t-2">
                    <button
                      type="submit"
                      className="btn zoom-element btn login-btn m-0 mr-auto"
                    >
                      <i className="fa fa-check-circle" /> Search
                    </button>
                    <button
                      type="button"
                      onClick={handleClear}
                      className="btn zoom-element btn login-btn m-0 ml-auto"
                    >
                      <i className="fa fa-times-circle" /> Clear
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* Loader */}
            <div
              id="corporate-search-loader"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading" id="adv-loader-alt" />
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier fas fa-search" />
                    Searching ...
                  </div>
                </div>
              </div>
            </div>

            {/* Success Message */}
            <div
              id="corporate-search-success"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <div className="form-loader form-loader-login verify">
                <div className="centerLoader">
                  <div className="loading success-loader">
                    <i className="webapp-ripple-notification success-text fa fa-check-circle" />
                  </div>
                  <div className="center-txt webapp-ripple-text">
                    <i className="notifier far fa-check-circle" />
                    Search Successful
                  </div>
                </div>
              </div>
            </div>

            {/* Error */}
            <div
              id="corporate-search-error"
              className="hidden loading-overlay speed-1x fadeInRight"
            >
              <ErrorLoader
                icon="fas fa-wifi"
                text="Network Issue"
                subText="Unable to connect to Advancly services."
              />
            </div>
          </React.Fragment>
        </div>
      </div>
    </div>
  );
};

export default AdvancedCorporateSearchModal;
